module.exports = __webpack_public_path__ + "static/media/amount-blue.6f7da3ce.svg";